import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MDBox from "components/MDBox";
import projectDefaultImage from "../../../../assets/images/landingpage/projectDefault.png";
import SimpleBlogCard from "examples/Cards/BlogCards/SimpleBlogCard";
import noData from "../../../../assets/images/landingpage/noData.jpeg";

import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";
import { useEffect, useState } from "react";
import { API_URL } from "config";
import { CircularProgress } from "@mui/material";

function Projects() {
  const [loading, setLoading] = useState(false);
  const [projects, setProjects] = useState([]);

  // Fetch homepage projects from the server
  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await fetch(
          `${API_URL}/projects/gethomepageprojects`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              // Authorization: `Bearer ${user.token}`,
            },
          }
        );

        const projectsjson = await response.json();

        if (response.ok) {
          setProjects(projectsjson);
        }
        if (!response.ok) {
          throw new Error("Failed to fetch projects");
        }
      } catch (error) {
        console.error("Error fetching projects:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  return (
    <MDBox component="section" py={2}>
      <Container maxWidth="lg">
        <Grid
          container
          spacing={3}
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          textAlign="center"
        >
          <Grid item xs={12} lg={6}>
            <MDBadge
              badgeContent="projects"
              variant="contained"
              color="info"
              container
            />
            <MDTypography variant="h2" mt={2}>
              Explore some of the best Projects
            </MDTypography>
            <MDTypography
              variant="body2"
              align="center"
              color="text"
              gutterBottom
            >
              Learn from the best and smoothly complete your research
            </MDTypography>
          </Grid>
          {loading ? (
            <MDBox>
              <CircularProgress />
            </MDBox>
          ) : projects.length === 0 ? (
            <Grid item xs={12}>
              <MDBox
                display="flex"
                justifyContent="center"
                alignItems="center"
                flexDirection="column"
              >
                <img src={noData} alt="No projects available" width="200" />
                {/* <MDTypography
                  variant="body2"
                  align="center"
                  color="text"
                  gutterBottom
                >
                  No projects available at the moment. Please check back later.
                </MDTypography> */}
              </MDBox>
            </Grid>
          ) : (
            <Grid
              container
              spacing={3}
              alignItems="stretch" // Ensures all cards have the same height
              justifyContent="center"
              mt={4}
            >
              {projects.map((project, index) => (
                <Grid
                  key={index}
                  item
                  xs={12}
                  md={6}
                  lg={4}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                  mb={4}
                >
                  <SimpleBlogCard
                    image={project.photo || projectDefaultImage}
                    title={project.projectTitle}
                    description={project.projectDescription}
                    action={{
                      type: "internal",
                      route: "/viewproject",
                      color: "info",
                      variant: "outlined",
                      label: "view project",
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          )}
        </Grid>
      </Container>
    </MDBox>
  );
}

export default Projects;
